import axios from "axios";
import { neshanKEY,neshanURL } from "../config";

const neshan = axios.create({
    baseURL:neshanURL
});

neshan.interceptors.request.use(
    function (config) {
            config.headers={'Api-Key':neshanKEY};
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

export const categries = {
    'region': 'منطقه',
    'municipal': 'محله',
    'place':'مکان'
}
export const typies = {
    'town': 'شهر',
    'county': 'شهرستان',
    'motorway': 'بزرگراه',
    'interests': 'امکان دیدنی',
    'train_station': 'راه آهن',
    'hospital': 'بیمارستان',
    'roundabout': 'میدان',
    'secondary': 'ثانویه',
    'shopping_mall': 'مرکز خرید',
    'local_government_office': 'مرکز دولتی',
    'university': 'دانشگاه',
    'state': 'استان',
    'hamlet': 'دهکده',
    'village': 'روستا'
}

export default neshan;
